import { render, staticRenderFns } from "./DocumentRow.vue?vue&type=template&id=5ae5ac0c&"
import script from "./DocumentRow.vue?vue&type=script&lang=js&"
export * from "./DocumentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae5ac0c')) {
      api.createRecord('5ae5ac0c', component.options)
    } else {
      api.reload('5ae5ac0c', component.options)
    }
    module.hot.accept("./DocumentRow.vue?vue&type=template&id=5ae5ac0c&", function () {
      api.rerender('5ae5ac0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/documents/partials/DocumentRow.vue"
export default component.exports